import { useCallback, useEffect, useMemo, useState } from 'react';
const EMPTY_TOTALS = new Map();
function areTotalsEqual(prev, next) {
    if (prev === next) {
        return true;
    }
    if (prev.size !== next.size) {
        return false;
    }
    for (const [key, value] of prev) {
        if (next.get(key) !== value) {
            return false;
        }
    }
    return true;
}
export function useTableTotals(totalVisibility, tableTotalsService, columns, rows, isShowTotals, subscribeTableUpdate) {
    const [formattedTotals, setFormattedTotals] = useState(EMPTY_TOTALS);
    const totalColumns = useMemo(() => columns.filter((column) => (column.totalVisibility & totalVisibility) !== 0), [columns]);
    const updateTotals = useCallback(() => {
        if (!isShowTotals) {
            setFormattedTotals((prev) => (prev.size === 0 ? prev : EMPTY_TOTALS));
            return;
        }
        const newTotals = new Map();
        totalColumns.forEach((column) => {
            const total = tableTotalsService.calculate(column, rows);
            newTotals.set(column.id, tableTotalsService.format(column, rows, total));
        });
        setFormattedTotals((prev) => (areTotalsEqual(prev, newTotals) ? prev : newTotals));
    }, [totalColumns, rows, isShowTotals, tableTotalsService]);
    useEffect(() => {
        updateTotals();
        if (!isShowTotals || isNullOrUndefined(subscribeTableUpdate)) {
            return;
        }
        let timeoutId = null;
        const scheduleTotalsUpdate = () => {
            if (!isNullOrUndefined(timeoutId)) {
                return;
            }
            timeoutId = setTimeout(() => {
                timeoutId = null;
                updateTotals();
            }, 0);
        };
        const unsubscribeTableUpdate = subscribeTableUpdate(scheduleTotalsUpdate);
        return () => {
            unsubscribeTableUpdate();
            if (!isNullOrUndefined(timeoutId)) {
                clearTimeout(timeoutId);
            }
        };
    }, [subscribeTableUpdate, updateTotals, isShowTotals]);
    return { formattedTotals };
}
